import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceEditResourceNotificationState = createStateReducer(initialState, {
  [events.editResourceSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editResource",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.editResourceFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "editResource",
        flags: [],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceEditResourceNotificationState };
